export default __webpack_public_path__ + "static/media/PEN_Xmas2021_GiftGuide_Page_10.92e639e9.jpg";